<template>
  <div class="pushswitch">
    <el-row :gutter="20">
      <el-col :span="14">
        <el-card shadow="never">
          <div slot="header" class="clearfix"><span>故障推送项目列表</span></div>
          <div class="button-tools">
            <div class="search-input">
              <el-input placeholder="请输入项目关键字" v-model="keywords" @input="getList" clearable />
              <!-- <el-autocomplete
                class="inline-input"
                value-key="projectName"
                v-model="keywords"
                @input="getList"
                :fetch-suggestions="querySearch"
                placeholder="请输入项目关键字"
                clearable
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete> -->
            </div>
          </div>
          <el-table
            ref="filterTable"
            :data="tableData"
            @select="selectRow"
            @row-click="rowClick"
            @select-all="selectRowAll"
            style="width: 100%"
            maxHeight="610"
            highlight-current-row
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="projectName" label="项目名称" width="180"></el-table-column>
            <el-table-column prop="projectId" label="项目编号" width="150"></el-table-column>
            <el-table-column prop="groupIds" label="所属组织" :filters="filtersData" :filter-method="filterTag" filter-placement="bottom-end" min-width="200">
              <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.groupIds" :key="index" :type="item.groupName === '云储能大数据综合服务平台' ? 'primary' : 'success'" disable-transitions>
                  {{ item.groupName }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="leveTwoNotifySwitch" label="二级故障开关" width="110">
              <template slot="header" slot-scope="scopex">
                <span>二级故障开关</span>
                <el-switch @change="changeSwitch(1)" :active-value="0" :inactive-value="1" v-model="leveTwoNotifySwitch" active-color="#00aaff" inactive-color="#c3c3c3"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch
                  @change="changeSwitchFault(scope.row)"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="scope.row.leveTwoNotifySwitch"
                  active-color="#00aaff"
                  inactive-color="#c3c3c3"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="leveThreeNotifySwitch" label="三级故障开关" width="110">
              <template slot="header" slot-scope="scopex">
                <span>三级故障开关</span>
                <el-switch @change="changeSwitch(2)" :active-value="0" :inactive-value="1" v-model="leveThreeNotifySwitch" active-color="#00aaff" inactive-color="#c3c3c3"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch
                  @change="changeSwitchThreeFault(scope.row)"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="scope.row.leveThreeNotifySwitch"
                  active-color="#00aaff"
                  inactive-color="#c3c3c3"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="eventNotifySwitch" label="事件推送开关" width="110">
              <template slot="header" slot-scope="scopex">
                <span style="float: left;">事件推送开关</span>
                <el-switch @change="changeSwitch(0)" :active-value="0" :inactive-value="1" v-model="eventNotifySwitch" active-color="#00aaff" inactive-color="#c3c3c3"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch
                  @change="changeSwitchEvent(scope.row)"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="scope.row.eventNotifySwitch"
                  active-color="#00aaff"
                  inactive-color="#c3c3c3"
                ></el-switch>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card shadow="never">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-card shadow="never">
                <div slot="header" class="clearfix"><span>二级故障推送</span></div>
                <Tree :treedata="faultDataTree" @setTree="setSaveTree" ref="tree1" :typeId="1"></Tree>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="never">
                <div slot="header" class="clearfix"><span>三级故障推送</span></div>
                <Tree :treedata="threeStageFaultDataTree" @setTree="setSaveTree" ref="tree3" :typeId="2"></Tree>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="never">
                <div slot="header" class="clearfix"><span>事件推送</span></div>
                <Tree :treedata="eventDataTree" @setTree="setSaveTree" ref="tree2" :typeId="0"></Tree>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import API from '@/api/parameter';
import Tree from '@/components/tree';
export default {
  components: {
    Tree
  },
  data() {
    return {
      keywords: '',
      projectId: '',
      tableData: [],
      filtersData: [{ text: '云储能大数据综合服务平台', value: '云储能大数据综合服务平台' }, { text: '徐水测试组', value: '徐水测试组' }],
      eventDataTree: [],
      faultDataTree: [],
      threeStageFaultDataTree: [],
      leveTwoNotifySwitch: 1,
      leveThreeNotifySwitch: 1,
      eventNotifySwitch: 1,
      currentRow: {}, //当前行
      currentCheckArray: [],
      isSetAll: false //是否是批量设置
    };
  },
  created() {
    this.projectInfosWithPushSwitch();
    this.userInfosWithPushSwitch(0);
    this.userInfosWithPushSwitch(1);
    this.userInfosWithPushSwitch(2);
  },
  mounted() {
    this.setDisabled(true);
  },
  methods: {
    //设置允许禁用
    setDisabled(e) {
      this.$refs.tree1.setDisabled(e);
      this.$refs.tree2.setDisabled(e);
      this.$refs.tree3.setDisabled(e);
    },
    //点击当前行
    rowClick(row, c, e) {
      this.setDisabled(false);
      this.$refs.filterTable.clearSelection();
      this.$refs.filterTable.toggleRowSelection(row, true);
      this.projectId = row.projectId;
      //获取单项目树
      this.userInfosWithPushSwitch(0);
      this.userInfosWithPushSwitch(1);
      this.userInfosWithPushSwitch(2);
    },
    //checked当前行
    selectRow(e, row) {
      this.currentCheckArray = [];
      e.forEach(item => {
        this.currentCheckArray.push(item.projectId);
      });
      this.setDisabled(false);
      if (e.length == 0) {
        this.isSetAll = false;
        this.projectId = '';
        this.setDisabled(true);
      } else if (e.length > 0) {
        this.isSetAll = true;
        this.projectId = '';
        this.$refs.filterTable.setCurrentRow();
      } else {
        this.isSetAll = false;
        this.projectId = e.projectId;
      }
      console.log(e);
      //获取单项目树
      this.userInfosWithPushSwitch(0);
      this.userInfosWithPushSwitch(1);
      this.userInfosWithPushSwitch(2);
    },
    //全选checklist
    selectRowAll(e) {
      console.log(e);
      this.currentCheckArray = [];
      e.forEach(item => {
        this.currentCheckArray.push(item.projectId);
      });
        this.setDisabled(false);
      if (e.length == 0) {
        this.setDisabled(true);
        this.isSetAll = false;
        this.projectId = '';
      } else if (e.length > 0) {
        this.isSetAll = true;
        this.projectId = '';
      } else {
        this.isSetAll = false;
        this.projectId = '';
      }
      //获取单项目树
      this.userInfosWithPushSwitch(0);
      this.userInfosWithPushSwitch(1);
      this.userInfosWithPushSwitch(2);
    },
    //保存推送树
    setSaveTree(e) {
      let params = { userIds: e.data, notifyType: e.typeId };
      //批量保存
      if (this.isSetAll == true) {
        params.projectIds = this.currentCheckArray;
      } else {
        //单个项目保存
        params.projectIds = [this.projectId];
      }
      this.updateUserStatusWithPushSwitchsForProject(params);
    },
    //保存推送开关人员
    async updateUserStatusWithPushSwitchsForProject(params) {
      let res = await API.updateUserStatusWithPushSwitchsForProject(params);
      if (res.data.code == 200) {
        this.$message.success('操作成功');
        this.projectInfosWithPushSwitch();
      }
    },
    // 获取项目开关列表
    async projectInfosWithPushSwitch() {
      let params = { searchKey: this.keywords };
      let res = await API.projectInfosWithPushSwitch(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data;
        this.getFiltersData(this.tableData);
      }
    },
    //获取人员树状列表
    async userInfosWithPushSwitch(notifyType) {
      let params = { projectId: this.projectId, notifyType: notifyType };
      let res = await API.userInfosWithPushSwitch(params);
      if (res.data.code == 200) {
        if (notifyType == 0) {
          this.eventDataTree = res.data.data;
        }
        if (notifyType == 1) {
          this.faultDataTree = res.data.data;
        }
        if (notifyType == 2) {
          this.threeStageFaultDataTree = res.data.data;
        }
      }
    },
    //推送开关更改状态-单个
    async updateStatusWithPushSwitch(params) {
      let res = await API.updateStatusWithPushSwitch(params);
      if (res.data.code == 200) {
        this.$message.success('操作成功');
      }
    },
    //推送开关更改状态-多个
    async updateStatusWithPushSwitchs(params) {
      let res = await API.updateStatusWithPushSwitchs(params);
      if (res.data.code == 200) {
        this.$message.success('操作成功');
      }
    },
    //单个事件开关切换
    changeSwitchEvent(e) {
      let params = { notifyStatus: e.eventNotifySwitch, notifyType: 0, projectId: e.projectId };
      this.updateStatusWithPushSwitch(params);
    },
    //单个二级故障开关切换
    changeSwitchFault(e) {
      let params = { notifyStatus: e.leveTwoNotifySwitch, notifyType: 1, projectId: e.projectId };
      this.updateStatusWithPushSwitch(params);
    },
    //单个三级故障开关切换
    changeSwitchThreeFault(e) {
      let params = { notifyStatus: e.leveThreeNotifySwitch, notifyType: 2, projectId: e.projectId };
      this.updateStatusWithPushSwitch(params);
    },
    //多个个推送开关切换
    changeSwitch(f) {
      let params = {};
      if (f == 0) {
        //事件
        params.notifyStatus = this.eventNotifySwitch;
        params.notifyType = f;
        // params.projectId = this.currentCheckArray;
        this.updateStatusWithPushSwitchs(params);
      } else if (f == 1) {
        //二级故障
        params.notifyStatus = this.leveTwoNotifySwitch;
        params.notifyType = f;
        // params.projectId = this.currentCheckArray;
        this.updateStatusWithPushSwitchs(params);
      } else if (f == 2) {
        //三级故障
        params.notifyStatus = this.leveThreeNotifySwitch;
        params.notifyType = f;
        // params.projectId = this.currentCheckArray;
        this.updateStatusWithPushSwitchs(params);
      }
      this.projectInfosWithPushSwitch();
      console.log(f);
    },
    getList() {
      this.projectInfosWithPushSwitch();
    },
    //获取过滤分组
    getFiltersData(data) {
      let res = [];
      let tmp = [];
      data.forEach(item => {
        item.groupIds.forEach(it => {
          tmp.push(it.groupName);
        });
      });
      if (tmp.length) {
        tmp = this.COMM.unique(tmp);
        this.filtersData = [];
        tmp.forEach(item => {
          this.filtersData.push({ text: item, value: item });
        });
      }
    },
    resetDateFilter() {
      this.$refs.filterTable.clearFilter('date');
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      let has = false;
      row.groupIds.forEach(item => {
        if (value == item.groupName) {
          has = true;
        }
      });
      return has;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },

    //过滤表格项目
    querySearch(queryString, cb) {
      var restaurants = this.tableData;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.projectName.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    //点击过滤记录
    handleSelect(item) {
    }
  }
};
</script>

<style lang="scss">
.pushswitch {
  .button-tools {
    margin-bottom: 10px;
  }
  .search-input {
    display: inline-block;
    width: 200px;
    margin-right: 20px;
    .inline-input {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/parameters/pushswitch.vue